import SupportCaseDetailsBlock from './SupportCaseDetailsBlock';

export default SupportCaseDetailsBlock;
